module.exports = require("core-js/library/fn/object/keys");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/keys.js